<template>
  <div class="admin-translate">
    <header-title title="Traducciones Subcategorías"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="subCategory in paginatedData" :key="subCategory.id">
          <Translate
            :data="subCategory"
            @saveToCollection="saveToSubCategoryCollection"
          ></Translate>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredCategory.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import Translate from "@/components/admin/translate/Translate";
import { subCategoriesCollection } from "@/collections/subCategories";
import { updateSubCategory } from "@/collections/subCategories";

export default {
  name: "TranslateSubcategory",
  components: {
    HeaderTitle,
    Loader,
    Translate
  },
  data() {
    return {
      dialogLoader: false,
      search: "",
      subCategoriesCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      subCategoriesCollection: subCategoriesCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredCategory() {
      let _subCategory = [...this.subCategoriesCollection];

      return this.search
        ? _subCategory.filter(category =>
            category?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _subCategory;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredCategory.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToSubCategoryCollection(input) {
      try {
        await updateSubCategory(input.id, input);
        this.showSuccessMessage("Traducciones Subcategorías actualizado");
      } catch (error) {
        this.setlogError(
          "save/update_sub_category",
          "Obtained error message in saveToSubCategoryCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
